/**
 * 变更来源场景 → 中文描述（契约取值见 swiftx-map-service/doc/address-lifecycle/design.md §3.2）。
 * 未知场景兜底显示原始值，保证新增 scene 时页面不炸。
 */
export const SCENE_LABELS: Record<string, string> = {
  standardize_create: '标准化新建',
  maptool_manual_create: '后台手工建址',
  external_api_refine: '外部API补全/升级',
  driver_feedback_approve: '司机上报-审核回写',
  console_coord_edit: '运营手改坐标',
  coord_calibrate_console: '坐标校准回写',
  coord_calibrate_rollback: '坐标校准回滚',
  aoi_correction_inc: 'AOI校正(增量)',
  aoi_correction_full: 'AOI校正(全量)',
  aoi_correction_manual: 'AOI校正(手动)',
  algo_coord_update: '算法坐标更新',
  pelias_correction: 'Pelias地址修正',
  survey_calibration: '实采坐标校准(Survey)',
  // 查询侧实时拼装的模拟节点 (CH 中无出生记录的存量老地址), 非真实埋点记录
  lazy_baseline: '存量基线（模拟）',
};

export const CHANGE_TYPE_LABELS: Record<string, string> = {
  INSERT: '新建',
  UPDATE: '修改',
  DELETE: '删除',
  SNAPSHOT: '基线快照',
};

export const CHANGE_TYPE_COLORS: Record<string, string> = {
  INSERT: 'green',
  UPDATE: 'blue',
  DELETE: 'red',
  SNAPSHOT: 'gold',
};

/** changed_table → 中文标签; 未知表兜底显示原始表名 (扩展表接入时在此补映射)。 */
export const TABLE_LABELS: Record<string, string> = {
  address_core: '地址主表',
};

export const tableLabel = (table: string): string => TABLE_LABELS[table] ?? table;
export const sceneLabel = (scene: string): string => SCENE_LABELS[scene] ?? scene;
export const changeTypeLabel = (type: string): string => CHANGE_TYPE_LABELS[type] ?? type;

/**
 * 从 before/after JSON 对象里按契约字段名取值。
 * 兼容两种键风格：坐标类记录为 snake_case（latitude/geo_hash），
 * 内容类记录（external_api_refine 全量对象）为 camelCase（unitNumber/plus4Code）。
 */
export const pickField = (obj: Record<string, unknown> | null, snakeName: string): unknown => {
  if (!obj) return undefined;
  if (snakeName in obj) return obj[snakeName];
  const camel = snakeName.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());
  return obj[camel];
};

export const parseJsonSafe = (raw: string | null): Record<string, unknown> | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as Record<string, unknown>) : null;
  } catch {
    return null;
  }
};

export const formatValue = (v: unknown): string => {
  if (v === undefined || v === null || v === '') return '—';
  return String(v);
};

// Long 标量在响应里序列化为字符串, 必须 Number() 后再构造 Date (new Date("178...") 是 Invalid Date)
export const formatTime = (ms: number | string | null): string =>
  ms ? new Date(Number(ms)).toLocaleString() : '—';
